<template>
    <div class="checkbox-li">
        <div
            class="check-box-container"
            :class="{ 'disabled': disabled }"
            :style="checkboxStyle"
            @click="onClick"
        >
            <span class="iconfont icon-checked" v-show="checked"></span>
        </div>
        <span class="label cursor" v-if="label">{{ label }}</span>
    </div>
</template>

<script>
export default {
    emits: ['change'],
    props: ['kee', 'label', 'checked', 'color', 'fontColor', 'disabled'],
    computed: {
        checkboxStyle({ color, fontColor }) {
            let obj = {};
            if (color) {
                obj.borderColor = color;
            }
            if (fontColor) {
                obj.color = color;
            }
            return obj;
        }
    },
    methods: {
        onClick() {
            if (this.disabled) {
                return false
            }
            this.$emit('change', {
                checked: !this.checked,
                kee: this.kee,
                label: this.label
            });
        }
    }
};
</script>

<style lang="scss">
@import '../theme/mixin.scss';
.checkbox-li {
    line-height: 28px;
    .label {
        padding-left: 10px;
    }
    .check-box-container {
        width: 15px;
        height: 15px;
        border: 1px solid var(--color-border);
        color: var(--g-btn-background);
        cursor: pointer;
        margin-right: 10px;
        display: inline-flex;
        position: relative;
        .icon-checked {
            position: absolute;
            font-size: 13px;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
        &.disabled {
            opacity: 0.3;
            &::after {
                cursor: not-allowed !important;
            }
        }
    }
}
</style>
